import script from "./HalfGames.vue?vue&type=script&setup=true&lang=js"
export * from "./HalfGames.vue?vue&type=script&setup=true&lang=js"

import "./HalfGames.vue?vue&type=style&index=0&id=10f4819c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10f4819c"]])

export default __exports__